import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { WinYourWishlistWidgetResource } from "JS/dxp/types/widgets/win-your-wishlist-widget";


export default /*#__PURE__*/_defineComponent({
  __name: 'WinYourWishlistWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: WinYourWishlistWidgetResource
}



const data = computed(() => props.widget.data);

const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: data.value.bannerLinkUrl,
	promoName: `${data.value.title}. ${data.value.subtitle}`,
	creativeSlot: 'win_your_wishlist_1',
	creativeName: 'dxp_win_your_wishlist_1',
}));

const bgImage = computed(() => `url(${data.value.backgroundImageUrl}`);
const bgImageMobile = computed(() => `url(${data.value.backgroundImageUrlMobile})`);


return { __sfc: true,props, data, gaDataAttributes, bgImage, bgImageMobile, cssVarsToStyleString }
}

})